export enum PhotoSize {
    XS = "XS", // max. 100x100
    S = "S", // max. 200x200
    M = "M", // max. 400x400
    L = "L", // max. 800x800
    XL = "XL", // max. 1600x1600
    XXL = "XXL", // max. 4000x4000
    ORIGINAL = "ORIGINAL", // original size
}
